module.exports = __webpack_public_path__ + "img/image24.07c4d2a9.png";